import { render, staticRenderFns } from "./inverstors.vue?vue&type=template&id=cfd1b384"
import script from "./inverstors.vue?vue&type=script&lang=js"
export * from "./inverstors.vue?vue&type=script&lang=js"
import style0 from "./inverstors.vue?vue&type=style&index=0&id=cfd1b384&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports